import type { Locale } from '#lib/paraglide/runtime.js';

export type LanguageOption = {
	readonly locale: Locale;
	readonly name: string;
};

/** What each language calls itself. A language named in another is a language nobody finds. */
export const LANGUAGE_NAMES: Partial<Record<Locale, string>> = {
	'nb-NO': 'Norsk',
	'en-GB': 'English',
	'sv-SE': 'Svenska'
};

export function otherLanguages(all: readonly Locale[], current: Locale): readonly LanguageOption[] {
	return all.flatMap((locale) => {
		if (locale === current) return [];

		const name = LANGUAGE_NAMES[locale];
		return name === undefined ? [] : [{ locale, name }];
	});
}
